import axios from "axios";

export const getListaKpiApi = (filtri = '') => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${filtri}`);
};

export const getKpiByIdAndTipoApi = (idKpi, idTipoImport) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}?id_tipo_imp_dati=${idTipoImport}`);
};

export const getKpiByIdApi = (idKpi) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}`);
};

export const getStrutturaKpiApi = (idKpi, filtri = '') => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/struttura-kpi/${filtri}`);
};

export const rimuoviStrutturaKpiApi = (idKpi) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/struttura-kpi/`);
};

export const aggiungiStrutturaKpiApi = (idKpi, tabella) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/struttura-kpi/`, tabella);
};

export const caricaTemplateKpiApi = (idKpi, formData) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/template/`, formData);
};

export const aggiungiKpiControlloApi = (idKpi, rel) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/rel-checks/`, rel);
};

export const aggiornaValoriTabellaKpiApi = (idKpi, tabella) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/struttura-kpi/valori/`, tabella)
}

export const aggiornaValoriTabellaKpiAndTipoApi = (idKpi, idTipoImport, tabella) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/struttura-kpi/valori/?id_tipo_imp_dati=${idTipoImport}`, tabella)
}

export const aggiungiValoriTabellaKpiApi = (idKpi, idTipoImport, tabella) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/struttura-kpi/valori/?id_tipo_imp_dati=${idTipoImport}`, tabella)
}

export const getControlliKpiApi = (idKpi) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/rel-checks/`);
};

export const rimuoviRelazioneKpiControlloApi = (idKpi, idRel) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/rel-checks/${idRel}`);
};

export const aggiornaKpiApi = (idKpi, kpi) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}`, kpi);
};

export const aggiungiKpiApi = (kpi) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/`, kpi);
};

export const aggiungiSottolivelloKpiApi = (idKpi, tabella, idxLivello, idxSottolivello) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/sottolivelli/${idxLivello}/${idxSottolivello}`, tabella);
};

export const getstrutturaGerarchicaKpiApi = (idSel, categoria) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/struttura/${idSel}?categoria=${categoria}`);
};

export const rimuoviKpiApi = (idKpi) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}`);
};

export const aggiornaStatoValoriKpiApi = (idKpi, stato) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/stati`, stato);
};

export const getModificheKpiApi = (idKpi, idTipoImportDati) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/struttura-kpi/modifiche/?id_tipo_imp_dati=${idTipoImportDati}`);
};

export const getStrutturaModificaSelApi = (idKpi, modificaSel, idTipoImportDati) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/struttura-kpi/modifiche/${modificaSel}?id_tipo_imp_dati=${idTipoImportDati}`);
};

export const getTipiKpiApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/tipi/`);
};

export const downloadTemplateDataPoint = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/template-import/`);
};

export const aggiornaElementoKpiApi = (idElemento, elemento) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/elemento/${idElemento}`, elemento);
};